import produce from "immer";
import queryString from "query-string";
import {ACTION_TYPE, HOST} from "utils/constants";

const getPid = () => {
  const search = queryString.parse(window.location.search);
  return search.pid ? `${HOST}_${search.pid}` : "test";
};

const initialState = {
  currentRoom: getPid(),
  chatList: [],
  chatMode: false,
  alert: false,
};

const chat = (state = initialState, action) => {
  const {type, payload} = action;

  switch (type) {
    case ACTION_TYPE.EDIT_ROOM:
      return produce(state, draft => {
        draft.currentRoom = payload;
      });
    case ACTION_TYPE.ADD_CHAT_LIST:
      return produce(state, draft => {
        draft.chatList.push(payload);
      });
    case ACTION_TYPE.EDIT_CHAT_MODE:
      return produce(state, draft => {
        if (draft.chatMode !== payload) {
          draft.chatMode = payload;
        }
      });
    case ACTION_TYPE.SET_CHAT_ALERT:
      return produce(state, draft => {
        draft.alert = payload;
      });
    default:
      return state;
  }
};

export default chat;
